import { CheckedIcon } from 'components/icons/checkedIcon'
import React, { ReactElement, FC } from 'react'
import { ProgressBar } from './progressBar'
import './style.scss'
import { ArrowIcon } from 'components/icons/arrowIcon'
interface Props {
  quorumReached: boolean
  party: string
  percentage: number
  changePercentage?: number
  color: string
}
export const Row: FC<Props> = ({
  party,
  percentage,
  changePercentage,
  quorumReached,
  color
}): ReactElement => {
  const gainedVotes = changePercentage
    ? +changePercentage === 0
      ? 0
      : changePercentage > 0
    : changePercentage

  return (
    <div>
      <div className='row'>
        <div className='party'>
          {party}
          {/* {quorumReached && <CheckedIcon />} */}
        </div>
        <div className='percentage'>{percentage}%</div>
        <div
          className={
            gainedVotes === 0
              ? 'change-percentage'
              : gainedVotes
              ? 'win-color change-percentage'
              : 'lose-color change-percentage'
          }
        >
          {/* {changePercentage && (
            <>
              <ArrowIcon
                rotation={
                  changePercentage > 2
                    ? -90
                    : changePercentage > 0
                    ? -45
                    : changePercentage < -2
                    ? 90
                    : changePercentage < 0
                    ? 45
                    : 0
                }
              />
              <div className='number'>
                {gainedVotes === 0
                  ? '=' + gainedVotes + '%'
                  : gainedVotes
                  ? '+' + changePercentage + '%'
                  : changePercentage + '%'}
              </div>
            </>
          )} */}
        </div>
      </div>
      <ProgressBar maxValue={50} value={percentage} color={color} />
    </div>
  )
}
